import {isLoaded} from 'Core/models/Async';
import {calculateRates, updateQuoteFormErrors} from 'Quoting/ducks/createQuote';
import {CompensationValue} from 'Quoting/models/DTOs/CompensationPayload';
import {isDefined, validateHealthProductQuote} from 'Quoting/utils/utilities';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';

export const useQuoteFormValidation = () => {
  const {selectedProduct, quote, quoteFormErrors, customerCensusClasses} = useSelector(
    (state: ReducerState) => state.quoteForm
  );
  const {BR_QuotingTool_EIS_Validation} = useSelector((state: ReducerState) => state.featureFlag);
  const compensationValue: CompensationValue = useSelector(
    (state: ReducerState) => state.compensation.compensationValue
  );

  const dispatch = useDispatch();

  return useCallback(() => {
    if (isLoaded(quote)) {
      if (BR_QuotingTool_EIS_Validation) {
        return dispatch(calculateRates(quote.Data, customerCensusClasses, true));
      }

      const validationResults = validateHealthProductQuote(
        quote?.Data,
        false,
        isDefined(compensationValue.rate) && compensationValue.rate.trim() !== ''
      );

      dispatch(updateQuoteFormErrors({...quoteFormErrors, ...validationResults}));
    }
  }, [selectedProduct?.code, quote]);
};
